module.exports = __webpack_public_path__ + "img/36187-037.dba326f1.jpg";